export function countWorkshops(workshopSabtuId, workshopMingguId) {
  return (workshopSabtuId ? 1 : 0) + (workshopMingguId ? 1 : 0);
}

export function calcWorkshopFee(workshopSabtuId, workshopMingguId, prices = {}) {
  const one = Number(prices.one ?? 1199000);
  const two = Number(prices.two ?? 1999000);
  const count = countWorkshops(workshopSabtuId, workshopMingguId);
  if (count === 0) return 0;
  if (count === 1) return one;
  return two;
}

export function formatIdr(amount) {
  return Number(amount || 0).toLocaleString('id-ID', { style: 'currency', currency: 'IDR' });
}

export function findWorkshopLabel(workshops, id) {
  if (!id) return '—';
  const all = [...(workshops?.sabtu || []), ...(workshops?.minggu || [])];
  const w = all.find((item) => String(item.id) === String(id));
  if (!w) return '—';
  return `${w.kode ? w.kode + ' — ' : ''}${w.judul}`;
}
